import type { PaymentFrequency } from '@subaio/api-types/shared'
import { FormattedMessage } from '@subaio/components'

type Props = {
	frequency: PaymentFrequency
}

export const Frequency = ({ frequency }: Props) => (
	<FormattedMessage
		id='frequency.default'
		defaultMessage={`{frequency, select,
			DAILY {daily}
			WEEKLY {weekly}
			BIWEEKLY {biweekly}
			MONTHLY {monthly}
			BIMONTHLY {bimonthly}
			QUARTERLY {quarterly}
			HALFYEARLY {half-yearly}
			YEARLY {yearly}
			other {–}
		}`}
		values={{ frequency }}
	/>
)
